export default __webpack_public_path__ + "static/media/presence.27e04507.jpg";